/*
* Method to handle the date formating.
* */
export function formatDate(dateString, $type = '') {
  const language = document.documentElement.lang;

  let options = { day: 'numeric', month: 'long', year: 'numeric' };
  if ($type === '2-digit') {
    options = { day: '2-digit', month: 'short', year: 'numeric' };
  }
  const formattedDate = new Date(dateString).toLocaleDateString(language, options);

  // Format the date with "1st" for the 1st day
  const formattedDateWithOrdinal = formattedDate.replace(/\b1\b/, (match) => {
    // Use the correct ordinal suffix based on the language
    if (language === 'fr') {
      return '1er';
    } else {
      return '1st';
    }
  });

  return formattedDateWithOrdinal;
}

/*
* Method to build the search conditions
* searchText: text value to search
* fieldsToSearch: array list of field names against which to compare with searchText
* specificSearches array list of searches to perform against specific fields
*   [{searchField: "field1", searchText: "value1"}, {searchField: "field2", searchText: "value2"}, ...]
*
* */
export function buildSearchConditionsContains(searchText, fieldsToSearch, specificSearches = []) {
  // Arbitrary limit to prevent huge inputs from overloading the number of criteria
  if (!searchText && specificSearches.length === 0) {
    return [];
  }

  const searchConditions = [];

  if (searchText) {
    for (const field of fieldsToSearch) {
      searchConditions.push({
        // operator 5 = contains
        field: field, operator: 7, value: searchText, connective: 0,
      });
    }
  }

  for (const specific of specificSearches) {
    searchConditions.push({
      // operator 5 = equal
      field: specific.searchField, operator: 5, value: specific.searchText, connective: 0,
    });
  }

  return searchConditions;
}

/*
* Method to build the sort condition.
* */
export function getSortingQuery(sortingQuery, directionSorting) {
  return [{
    property: sortingQuery, direction: directionSorting, sortPriority: 1,
  }];
}

/*
* Method to add the events for the custom input file
* */
export function handleFileInput() {
  const customFileSection = document.querySelectorAll('.file-custom');

  customFileSection.forEach(customFile => {
    const inputFile = customFile.querySelector('input[type="file"]');
    const uploadedFileName = customFile.querySelector('.file-name');
    const listeFileEl = customFile.querySelector('.selectedFile');

    if (uploadedFileName && uploadedFileName.value !== '') {
      listeFileEl.querySelectorAll('.name').forEach(nameEl => nameEl.innerText = uploadedFileName.value);
      listeFileEl.classList.remove('d-none');
    }

    customFile.querySelector('input[type="file"]').addEventListener('change', (e) => {
      const fileName = e.target.value.split('\\').pop();

      if (e.target.value !== '') {
        customFile.classList.add('not-empty');
        listeFileEl.querySelectorAll('.name').forEach(nameEl => {
          nameEl.innerText = fileName + ' (' + returnFileSize(inputFile.files[0].size) + ')';
        });
        listeFileEl.classList.remove('d-none');
      } else {
        customFile.classList.remove('not-empty');
        listeFileEl.classList.add('d-none')
      }
    });
  });
}

/*
* Method to assign default value to input file
* fieldId: the ID of the file input to update
* fileName: the name of the file sent by pivotal
* fileName: the filesize sent by pivotal
* */
export function handleFileInputDefault(fieldId, fileName, filesize = 0) {
  const input = document.getElementById(fieldId);

  if (input) {
    const customFile = input.closest('.file-custom')
    const listeFileEl = customFile.querySelector('.selectedFile');
    listeFileEl.querySelectorAll('.name').forEach(nameEl => {
      nameEl.innerText = fileName + ' (' + returnFileSize(filesize) + ')';
    });
    customFile.classList.add('not-empty');
    listeFileEl.classList.remove('d-none');
  }
}

/*
* Method to reset a input file
* fieldId: the ID of the file input to update
* */
export function handleClearFileInput(fieldId) {
  const input = document.getElementById(fieldId);

  if (input) {
    const customFile = input.closest('.file-custom');
    customFile.classList.remove('not-empty');
    const uploadedFileName = customFile.querySelector('.file-name');
    input.value = '';
    uploadedFileName.value = '';
    input.dispatchEvent(new Event('change'));
    input.focus();
  }
};

/*
* Method to format the file size from a byte number
* */
export function returnFileSize(number) {
  let termB = "bytes";
  let termK = "KB";
  let termM = "MB";
  if (document.documentElement.lang === "fr") {
    termB = 'octets'
    termK = 'Ko'
    termM = 'Mo'
  }
  if (number < 1024) {
    return `${number} ${termB}`;
  } else if (number >= 1024 && number < 1048576) {
    return `${(number / 1024).toFixed(1)} ${termK}`;
  } else if (number >= 1048576) {
    return `${(number / 1048576).toFixed(1)} ${termM}`;
  }
}

/*
* Method that handle the page navigation on buttons
* */
export function handleClickLinks(url = '', name = null, value = null) {
  if (value !== null && name !== null) {
    window.location.href = url + '?' + name + '=' + value;
  } else {
    window.location.href = url;
  }
}

export function navigateWithParams(url, params) {
  // Check if params is an object
  if (typeof params !== 'object' || params === null) {
    throw new TypeError('params must be an object');
  }

  // Build the query string
  const queryString = new URLSearchParams(params);

  // Combine url and query string
  const newUrl = `${url}?${queryString.toString()}`;

  // Navigate to the new URL
  window.location.href = newUrl;
}

export function updateHeadingBasedOnUrl(elId, param, defaultTxt, replacementTxt, overrideIsRenewal) {
  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = urlParams.get(param) === 'true' || overrideIsRenewal === true;

  const headingElement = document.getElementById(elId);

  if (headingElement) {
    if (isRenewal) {
      headingElement.textContent = replacementTxt;
    } else {
      headingElement.textContent = defaultTxt;
    }
  }
}

export function convertBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result.split(',')[1]);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

/*
* Method that resets custom error messages for the js validation
* */
export function resetErrMessages() {
  const txtElements = document.querySelectorAll('div.just-validate-error-label');
  txtElements.forEach(txtElement => {
    if (txtElement) {
      txtElement.remove();
    }
  });

  const oldValidatedElements = document.querySelectorAll('.just-validate-error-field');
  oldValidatedElements.forEach(oldElement => {
    if (oldElement) {
      oldElement.classList.remove('just-validate-error-field');
    }
  });
}

/*
* Method that find the removed items if there is any inside 2 array of objects.
* */
export function findRemovedItems(defaultObject, activeObject, type) {
  const removedItems = [];
  defaultObject.forEach(item => {
    const found = activeObject.some(activeItem => {
      let val = false;
      if (type === 'clients') {
        val = activeItem.Subject_Id === item.Subject_Id;
      } else if (type === 'regions') {
        val = activeItem.TM_Territory_Id === item.TM_Territory_Id;
      } else if (type === 'formateurs') {
        val = activeItem.Contact_Id === item.Contact_Id;
      } else if (type === 'notions') {
        val = activeItem.REDU_Sub_Subject_Id === item.REDU_Sub_Subject_Id;
      } else if (type === 'subject') {
        val = activeItem.Subject_Id === item.Subject_Id;
      }
      return val;
    });

    if (!found) {
      removedItems.push(item);
    }
  });

  return removedItems;
}


/*
* Methods that removes custom error messages for valid fields
* */
function removeError(element, errorLabelSelector) {
  if (element && element.value.trim() !== '') {
    element.classList.remove('just-validate-error-field');
    const formGroup = element.closest('.form-group');
    if (formGroup) {
      const errorLabel = formGroup.querySelector(errorLabelSelector);
      if (errorLabel) {
        errorLabel.remove();
      }
    }
  }
}

function removeErrFromTextInputs() {
  const textInputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], input[type="date"], input[type="file"], textarea');
  textInputs.forEach(input => {
    removeError(input, 'div.just-validate-error-label');
  });
}

function removeErrFromCheckboxes() {
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  checkboxes.forEach(checkbox => {
    if (checkbox && checkbox.checked) {
      removeError(checkbox, 'div.just-validate-error-label');
    }
  });
}

function removeErrFromSelects() {
  const selects = document.querySelectorAll('select');
  selects.forEach(select => {
    removeError(select, 'div.just-validate-error-label');
  });
}

export function removeErrFromValidItems() {
  removeErrFromTextInputs();
  removeErrFromCheckboxes();
  removeErrFromSelects();
}

export function removeErrFromFileInput() {
  const fileInputWrappers = document.querySelectorAll('.file-custom');
  fileInputWrappers.forEach(fileInputWrapper => {
    fileInputWrapper.classList.remove('just-validate-error-field');
  });
}

export function getQueryParams(qs) {
  let params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

export function clearSearchBtn(e, setInputSearchValue) {
  e.preventDefault();
  const searchInput = e.target.previousSibling;

  if (searchInput && setInputSearchValue) {
    setInputSearchValue('');
    searchInput.focus();
  }
}
